import map from './MapObj';
const snakeCase = require('to-snake-case');

function matches(patterns, value) {
  return patterns.some(function(pattern) {
    return typeof pattern === 'string'
      ? pattern === value
      : pattern.test(value);
  });
}

const snakecaseKeys = (obj, options) => {
  options = Object.assign({ deep: true, exclude: [] }, options);

  return map(
    obj,
    function(key, val) {
      return [matches(options.exclude, key) ? key : snakeCase(key), val];
    },
    options
  );
};

export default snakecaseKeys;
